import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cx } from '../../lib/util/cx';

/** Port of the DS `Textarea`: TextField's fill/border/focus, no resize, optional count. */
export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  surface?: 'cream' | 'white';
  invalid?: boolean;
  showCount?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { surface = 'cream', invalid = false, showCount = false, rows = 3, maxLength, disabled, value, className, ...rest },
  ref,
) {
  return (
    <div>
      <textarea
        ref={ref}
        rows={rows}
        maxLength={maxLength}
        disabled={disabled}
        value={value}
        aria-invalid={invalid || undefined}
        className={cx(
          'block w-full resize-none rounded-input border px-3.5 py-[13px] font-body text-[15px] leading-[1.5] text-ink',
          'transition-[border-color] duration-fast focus:border-orange focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-orange',
          disabled ? 'bg-[var(--hp-gray-100)]' : surface === 'white' ? 'bg-white' : 'bg-cream',
          invalid ? 'border-danger' : 'border-[rgba(143,68,32,.12)]',
          className,
        )}
        {...rest}
      />
      {showCount && maxLength != null && (
        <p className="m-0 mt-1 text-right font-body text-xs text-muted">
          {String(value ?? '').length}/{maxLength}
        </p>
      )}
    </div>
  );
});
